export const getStreamableEmbedURL = (videoId: string) => {
  return `https://streamable.com/e/${videoId}`
}
